function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SidebarPortal from './SidebarPortal';
import { SIDEBAR_NAV_ADMIN_LINKS, SIDEBAR_NAV_MANAGER_LINKS, SIDEBAR_NAV_CLIENT_LINKS, SIDEBAR_NAV_CONSULTANT_LINKS, SIDEBAR_NAV_SUPER_CONSULTANT_LINKS, SIDEBAR_NAV_ACCOUNTANT_LINKS } from '@rd-web-markets/market/dist/constants';
const MasterSidebar = _ref => {
  let {
    accountType,
    currentPage
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const {
    t
  } = useTranslation();
  const menuItems = useMemo(() => {
    let links;
    switch (accountType) {
      case 'admin':
        links = [...SIDEBAR_NAV_ADMIN_LINKS];
        break;
      case 'manager':
        links = [...SIDEBAR_NAV_MANAGER_LINKS];
        break;
      case 'customer':
        links = [...SIDEBAR_NAV_CLIENT_LINKS];
        break;
      case 'consultant':
        links = [...SIDEBAR_NAV_CONSULTANT_LINKS];
        break;
      case 'super_consultant':
        links = [...SIDEBAR_NAV_SUPER_CONSULTANT_LINKS];
        break;
      case 'accountant':
        links = [...SIDEBAR_NAV_ACCOUNTANT_LINKS];
        break;
      default:
        links = [...SIDEBAR_NAV_ADMIN_LINKS];
    }
    links = links.map(link => {
      if (link.link === currentPage) {
        return _objectSpread(_objectSpread({}, link), {}, {
          highlighted: true
        });
      }
      if (link.subMenu) {
        link = _objectSpread(_objectSpread({}, link), {}, {
          subMenu: link.subMenu.map(subLink => subLink.link === currentPage ? _objectSpread(_objectSpread({}, subLink), {}, {
            highlighted: true
          }) : subLink)
        });
      }
      return link;
    });
    if (user && user.show_dashboard && ['/uk', '/us'].includes(process.env.PUBLIC_URL)) {
      links.splice(4, 0, {
        text: t('dashboards'),
        link: 'dashboards',
        icon: 'dashboard',
        highlighted: currentPage === 'dashboards'
      });
    }
    return links;
  }, [accountType, currentPage, t, user]);
  return /*#__PURE__*/React.createElement(SidebarPortal, {
    menuItems: menuItems,
    headerItem: {
      text: 'Home',
      link: '',
      icon: 'home'
    },
    dividerPosition: 4
  });
};
export default MasterSidebar;